export class TurnoUtils {
  static calcularTurno(dataHora: string | Date | null | undefined): string {
    if (!dataHora) {
      return "---";
    }
    const data = new Date(dataHora);
    if (isNaN(data.getTime())) {
      return "---";
    }
    const hora = data.getHours();
    if (hora >= 7 && hora < 15) {
      return "Tarde";
    } else if (hora >= 15 && hora < 24) {
      return "Manhã";
    } else {
      return "Noite";
    }
  }
}
